<app-main-pages-container>
            <h1 translate>blog_title</h1>

            @for (group of groups$ | async; track group.title) {
                @if (group.title) {
                    <h2 class="article-group-title">
                        @if (group.slug) {
                            <a [routerLink]="'/' + group.slug">{{ group.title }}</a>
                        } @else {
                            {{ group.title }}
                        }
                    </h2>
                }

                <ul>
                    @for (article of group.articles; track article.id) {
                        <li class="article-item">
                            <a [routerLink]="['/blog', article.id]">{{ article.title }}</a>
                        </li>
                    }
                </ul>
            }

            <button mat-flat-button routerLink="">{{ 'home' | translate }}</button>
</app-main-pages-container>
